<template lang="pug">
v-container(v-if="$store.state.user && $store.state.user.role === 1")
    v-layout
        //- v-select(label="身分" :items="identities" v-model="identity" @change="getSurveys()")
        v-select(label="路線" :items="routes" v-model="route" @change="getSurveys()" placeholder="請選擇路線")
        v-select(label="類別" :items="categoryOptions" v-model="category" @change="getSurveys()" placeholder="請選擇類別")
    v-tabs(v-show="surveys.length" v-model="tab" dark touchless grow slider-color="lime lighten-2")
        v-tab.lime.darken-2 總分
        v-tab.lime.darken-2 選項
        v-tab.lime.darken-2 圖表
        v-tab-item
            div.result-block
                div.section-block
                    .overflow-x
                        table.table(ref="總分")
                            tbody
                                tr
                                    td 項目
                                tr(v-for="akey in allitem" :key="akey")
                                    td {{akey}}
                                    td(v-for="ikey in Object.keys(items)" :key="ikey") {{items[ikey][akey]==undefined?'':items[ikey][akey].toFixed(2)}}
            div.section-divider
            div.result-block
                div.section-block
                    .overflow-x
                        table.table
                            tbody
                                tr
                                    td 指標
                                tr(v-for="akey in allindex" :key="akey")
                                    td {{akey}}
                                    td(v-for="ikey in Object.keys(indexes)" :key="ikey") {{indexes[ikey][akey]==undefined?'':indexes[ikey][akey].toFixed(2)}}
            div.section-divider
            div.result-block
                div.section-block
                    .overflow-x
                        table.table
                            tbody
                                tr
                                    td 問項
                                tr(v-for="akey in allscore" :key="akey")
                                    td {{akey}}
                                    td(v-for="skey in Object.keys(scores)" :key="skey") {{formatScoreValue(scores[skey][akey], akey)}}
        v-tab-item
            .overflow-x
                table.table(ref="選項")
                    tbody
                        tr(v-for="stat,skey in stats" :key="skey")
                            td {{skey}}
                            td(v-for="sel,si in stat" :key="si") {{sel}}
        v-tab-item
            .d-flex.flex-wrap
                v-flex(v-for="pie in pies" :key="pie.title" xs12 sm6 md4)
                    .d-flex
                        v-spacer
                        .subheading.mr-3 {{pie.title}}
                    Chart(v-bind="pie")
    .psf-corner.orange
        .center-text
            h2 點選類別與身分開始
            h3 「總分」看進度與分數
            h3 「選項」看詳細填寫狀況
            h3 「圖表」看各選項統計比例
    v-snackbar(v-model="snackbar" :timeout="2000") {{category}}{{identity}}尚無問卷
    v-tooltip(top)
        template(v-slot:activator="{ on, attrs }")
            v-btn.ma-1(fab @click="exportExcel()" v-bind="attrs" v-on="on").psf
                v-icon mdi-arrow-down
        span 下載 Excel
</template>

<script>
import { db, shot2docs, colors, isObject } from '../main';
import Chart from './chart.vue';
import axios from 'axios';

export default {
    name: 'result',
    components: { Chart },
    data() {
        return {
            category: '',
            categories: {},
            categoryOptions: [],
            identity: '',
            identities: [],
            route: '',
            selectedRouteIds: [], 
            routes: [],
            stats: {},
            surveys: [],
            questions: {},
            scores: {},
            allscore: [' ', '已完成'],
            indexes: {},
            allindex: [],
            items: {},
            allitem: [],
            tab: 0,
            snackbar: false,
            target: '',
            questionTagMap: {},
            calculateTags: [],
            calculateTagsMerge: [],
            calculateIndicators: [],
            routeName: '',
            totalAverage: '0.00',
            finishedValue: '0.00',
        };
    },
    methods: {
        async loadAllOptions(){
			const year = this.$store.state.selectedYear;

            // 取得路線列表
			const routeAndBusinessAndUnitResponse = await axios.get('/api/Account/RouteAndBusinessAndUnitList',{
					params: { year }
				});
        
            if (routeAndBusinessAndUnitResponse.data.status && routeAndBusinessAndUnitResponse.data.result) {
                const result = routeAndBusinessAndUnitResponse.data.result;

                if (result.routes && Array.isArray(result.routes)) {
                    this.routes = result.routes.map(route => ({
                        text: route.name,
                        value: route.id,
                        identity_id: route.identity_id,
                    }));
                }
            } else {
            this.routes = [];
            }

            // 取得類別列表
            const categoryResponse = await axios.get('/api/Account/CategoryList');
			if (categoryResponse.data.status && categoryResponse.data.result) {
                const filtered = categoryResponse.data.result.filter(
                    category => category.id === 1 || category.id === 2
                );
				this.categories = filtered.map(category => category.name);
				this.categoryOptions = filtered.map(category => ({
					text: category.name,
					value: category.id
				}));
			} else {
				this.categories = [];
				this.categoryOptions = [];
            }
		},
        // 匯出Excel
        async exportExcel() {
			const year = this.$store.state.selectedYear;
            try {
                // type 1:總分，2:選項
                const type = this.tab === 0 ? 1 : 2;
                
                if (!this.route) {    
                    alert('請先選擇路線');    
                    return;
                }
                const routeId = Number(this.route);

                const res = await axios.post(
                    '/api/Questionnaire/Export',
                    { 
                        year: year,
                        routeId: routeId,
                        type: type,
                        category_id: this.category || 0 },
                    { responseType: 'blob' }
                );
                // 組檔名(日期)
                const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');

                let fileName = ''; 

                // 組完整檔名
                const selectedRoute = this.routes.find(r => r.value === routeId);
                const routeName = selectedRoute ? selectedRoute.text : `路線${routeId}`;
                if (type === 1) {
                    fileName = `總分-${routeName}-${dateStr}.xlsx`;
                } else {
                    fileName = `路線-${routeName}-${dateStr}.xlsx`;
                }

                const contentDisposition = res.headers['content-disposition'] || res.headers['Content-Disposition'] || '';
                // 解析檔名
                if (contentDisposition) {
                    let matches = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
                    if (matches && matches[1]) {
                        fileName = decodeURIComponent(matches[1]);
                    } else {
                        matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (matches && matches[1]) {
                            fileName = matches[1].replace(/['"]/g, '');
                            if (fileName.includes('%')) {
                                fileName = decodeURIComponent(fileName);
                            }
                        }
                    }
                }

                const blob = new Blob([res.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                alert('匯出失敗：' + (err.message || '未知錯誤'));
            }
        },
        // 取得所有答案表列表
        async getSurveys() {
			const year = this.$store.state.selectedYear;
            if (!this.route) {
                this.surveys = [];
                this.stats = {};
                return;
            }

            try {
                const res = await axios.get('/api/Questionnaire/QuestionnaireAnswerOptionList', {
                    params: { 
                        year,
                        id: this.route,
                        category_id: this.category || 0
                    }
                });

                const list = res.data.result || [];
                // 沒資料清空資料
                if (list.length === 0) {
                    this.surveys = [];
                    this.stats = {};
                    this.snackbar = true;
                    return;
                }
                // 整理後端傳回的格式
                this.surveys = list.map(x => ({
                    target: String(this.route),
                    account: x.account || '',
                    date: x.fill_date || '',
                    time: x.fill_time || '',
                    createAt: x.created_at || '',
                    items: (x.answers || []).map(a => ({
                        i: a.question_tag || '',
                        q: a.question_name || '',
                        s: a.answer || '',
                        o: ''
                    }))
                }));

                this.target = String(this.route);
                // 呼叫顯示答案表格function
                this.groupItems();
            } catch (err) {
                console.error('getSurveys error:', err);
                this.surveys = [];
                this.stats = {};
                this.snackbar = true;
            }
            // 呼叫計算各指標分數function
            await this.loadCalculateData();
        },
        // 計算各指標分數
        async loadCalculateData() {
			const year = this.$store.state.selectedYear;
            // 沒選清空資料
            if (this.category === null || this.category === undefined || this.category === '') {
                this.scores = {};
                this.indexes = {};
                this.items = {};
                this.allscore = ['已完成'];
                this.allindex = [];
                this.allitem = ['總分'];
                return;
            }

            const routeId = Number(this.route);
            try {
                const res = await axios.get('/api/Questionnaire/Calculate', {
                    params: {
                        id: routeId,
                        category_id: this.category || 0,
                        year,
                    }
                });

                const list = res.data.result;
                if (!Array.isArray(list) || list.length === 0) return;

                // 複製資料
                const scoreData = {};
                const indexData = {};
                const itemData = {};
                const allTag = new Set();
                const allTags = new Set();
                const allTagsMerge = new Set();

                // 處理每一條路線計算結果
                for (const r of list) {
                    const rName = r.route_name || '未知路線';
                    const tag = r.tag || [];
                    const tags = r.tags || [];
                    const tagsMerge = r.tags_merge || [];

                    tag.forEach(t => { if (t.question_name) allTag.add(t.question_name); });
                    tags.forEach(t => { if (t.question_tag) allTags.add(t.question_tag); });
                    tagsMerge.forEach(tm => { if (tm.question_tag_merge && tm.question_tag_merge !== '總分') allTagsMerge.add(tm.question_tag_merge); });

                    scoreData[rName] = {};
                    scoreData[rName]['已完成'] = r.finished || '0%';
                    tag.forEach(t => {
                        if (t.question_name) scoreData[rName][t.question_name] = t.score;
                    });

                    indexData[rName] = {};
                    tags.forEach(t => {
                        if (t.question_tag) indexData[rName][t.question_tag] = t.score;
                    });

                    itemData[rName] = {};
                    itemData[rName]['總分'] = r.total;
                    tagsMerge.forEach(tm => {
                        if (tm.question_tag_merge) itemData[rName][tm.question_tag_merge] = tm.score;
                    });
                }

                const tList = Array.from(allTag).sort();
                const tagList = Array.from(allTags).sort();
                const mergeList = Array.from(allTagsMerge).sort();

                this.allscore = ['已完成', ...tList];
                this.allindex = [...tagList];
                this.allitem = ['總分', ...mergeList];
                
                this.$set(this, 'scores', scoreData);
                this.$set(this, 'indexes', indexData);
                this.$set(this, 'items', itemData);
            } catch (err) {
                console.error('loadCalculateData error:', err);
            }
        },
        // 顯示格式化分數
        formatScoreValue(value, key) {
            if (value === undefined || value === null || value === '') {
                return '';
            }
            if (key === '已完成' && typeof value === 'string') {
                return value;
            }
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        },
        groupItems() {
            this.stats = {};
            this.questionTagMap = {};
            
            // 填表時間排序
            const surveys = this.surveys
                .filter((x) => x.target == this.target)
                .sort((a, b) => {
                    const dateTimeA = String(a.date + ' ' + a.time);
                    const dateTimeB = String(b.date + ' ' + b.time);
                    return dateTimeA.localeCompare(dateTimeB);
                });

            if (surveys.length === 0) {
                return;
            }

            // 整理時間格式
            this.stats['調查時間'] = surveys.map((x) => {
                if (x.date && x.time) {
                    return new Date(x.date + ' ' + x.time).toLocaleString('zh-TW');
                }
                return x.date + ' ' + x.time;
            });
            
            this.stats['填表時間'] = surveys.map((x) => x.createAt ? x.createAt.replace(/-/g, '/') : '');

            const questionMap = new Map(); 
            // 指標跟題目
            surveys.forEach(survey => {
                (survey.items || []).forEach(item => {
                    if (item.q && item.q.trim() !== '') {
                        if (!questionMap.has(item.q) || !questionMap.get(item.q)) {
                            questionMap.set(item.q, item.i || '');
                        }
                    }
                });
            });

            questionMap.forEach((tag, name) => {
                this.questionTagMap[name] = tag || '';
            });

            const allQuestionNames = Array.from(questionMap.keys());

            for (let questionName of allQuestionNames) {
                const questionTag = this.questionTagMap[questionName] || '';
                // 顯示指標跟題目
                const displayName = questionTag 
                    ? `${questionTag} ${questionName}` 
                    : questionName;
                // 對應的答案
                this.stats[displayName] = surveys.map((survey) => {
                    const matchedItems = survey.items.filter((y) => y.q === questionName);
                    if (!matchedItems.length) return '';
                    
                    const answers = matchedItems
                        .map(item => {
                            let answer = '';
                            if (Array.isArray(item.s)) answer = item.s.join(',');
                            else if (isObject(item.s)) answer = item.s.t || '';
                            else answer = String(item.s || '');
                            if (item.o) answer += (answer ? ' ' : '') + item.o;
                            return answer;
                        })
                        .filter(a => a);
                    
                    return answers.join(', ');
                });
            }
            
            // 帳號
            this.$set(
                this.stats,
                '帳號',
                surveys.map((x) => x.account || '')
            );
        },
    },
    // 繪製圖表結果
    computed: {
        pies() {
            if (!this.stats || Object.keys(this.stats).length === 0) {
                return [];
            }

            const excludeKeys = ['調查時間', '填表時間', '帳號'];
            
            const questionKeys = Object.keys(this.stats).filter(key => {
                if (excludeKeys.includes(key)) {
                    return false;
                }
                const values = this.stats[key];
                return Array.isArray(values) && values.length > 0;
            });

            if (questionKeys.length === 0) {
                return [];
            }

            return questionKeys.map(displayName => {
                const selects = this.stats[displayName] || [];
                
                const validSelects = selects
                    .map(s => {
                        if (s === null || s === undefined) return '';
                        return String(s).trim();
                    })
                    .filter(s => s !== '');

                if (validSelects.length === 0) {
                    return null;
                }

                const labels = [...new Set(validSelects)];
                
                const data = labels.map(label => {
                    return validSelects.filter(s => {
                        return String(s) === String(label);
                    }).length;
                });
                
                const backgroundColor = labels.map((_, index) => {
                    if (!colors || colors.length === 0) {
                        const defaultColors = [
                            '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
                            '#9966FF', '#FF9F40', '#FF6384', '#C9CBCF'
                        ];
                        return defaultColors[index % defaultColors.length];
                    }
                    const colorIndex = index % colors.length;
                    return colors[colorIndex].l || colors[colorIndex].p || '#CCCCCC';
                });

                return {
                    title: displayName,
                    type: 'pie',
                    data: data,
                    labels: labels,
                    backgroundColor: backgroundColor
                };
            }).filter(pie => pie !== null && pie.data.length > 0);
        },
    },
    // 監聽selectedYear的變化
    watch: {
		'$store.state.selectedYear'() {
			this.loadAllOptions();
		},
	},
    // 初始化
    mounted() {
        this.loadAllOptions();
    },
};
</script>
